import React, { useState, useEffect } from "react"

import "@/styles/component/select.scss"

type Option = {
  value: string,
  text: string
}
type Props = {
  name: string
  options: Array<Option>,
  register?: any,
  errors?: any,
}
const Select: React.FC<Props> = ({ name, options, register, errors }) => {
  const [selectedValue, setSelectedValue] = useState("0");

  return (
    <select name={name}
      defaultValue={selectedValue}
      onChange={e => {
        setSelectedValue(e.target.value)
      }}
      onBlur={e => setSelectedValue(e.target.value)}
      ref={register({ required: true })}
      className={`select ${selectedValue !== "0" ? "selected" : ""} ${errors && selectedValue === "0" ? "error" : ""}`}
    >

      <option disabled value="0">選択してください</option>
      {options.map((option, i) => {
        return <option key={i} data-i={i} value={option.value}>{option.text}</option>
      })}

    </select>
  )
}

export default Select
